export default "__VITE_ASSET__DpvPUrAa__"